import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ProMessagingAutomationListComponent} from './list/list.component';
import {ProMessagingAutomationEditComponent} from './edit/edit.component';
import {ProMessagingAutomationEditScheduleComponent} from './edit-schedule/edit-schedule.component';

export const routes: Routes = [
  {
    path: '',
    component: ProMessagingAutomationListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ProMessagingGroup,
      package: ModulesEnum.MessagingAutomationModule,
      permissions: [RolesEnum.MessagingAutomation_View, RolesEnum.MessagingAutomation_Edit, RolesEnum.MessagingAutomation_Delete],
      meta: {
        title: 'Automation',
        override: true,
        description: 'Auto reply for incoming messages',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'reply_all',
        showDisabled: false
      }
    }
  },
  {
    path: 'edit',
    canActivate: [AuthGuard],
    children: [
      {
        path: ':id',
        component: ProMessagingAutomationEditComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.ProMessagingGroup,
          package: ModulesEnum.MessagingAutomationModule,
          permissions: [RolesEnum.MessagingAutomation_Edit, RolesEnum.MessagingAutomation_Delete],
          meta: {
            title: 'Auto Reply Settings',
            override: true,
            description: 'Auto Reply Settings Page',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'reply_all',
          }
        }
      }
    ]
  },
  {
    path: 'edit-schedule',
    canActivate: [AuthGuard],
    children: [
      {
        path: ':id',
        component: ProMessagingAutomationEditScheduleComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.ProMessagingGroup,
          package: ModulesEnum.MessagingAutomationModule,
          permissions: [RolesEnum.MessagingAutomation_Edit, RolesEnum.MessagingAutomation_Delete],
          meta: {
            title: 'Scheduled Message Settings',
            override: true,
            description: 'Scheduled Message Settings Page',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'schedule',
          }
        }
      }
    ]
  }
];
